import { createWebSocketStore } from 'src/components/#services/helpers';
export const myTransactions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_getAllMy',
        agent: 'transactions',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
    getResult(value) {
        return Object.assign(Object.assign({}, value), { data: value.data.map(o => (Object.assign(Object.assign({}, o), { createdAt: new Date(o.createdAt), updatedAt: new Date(o.updatedAt) }))) });
    },
});
export const myTransactionsToday = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_getAllMy',
        agent: 'transactions',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
    getResult(value) {
        return Object.assign(Object.assign({}, value), { data: value.data.map(o => (Object.assign(Object.assign({}, o), { createdAt: new Date(o.createdAt), updatedAt: new Date(o.updatedAt) }))) });
    },
});
export const myTransactionsByCurrency = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_getMyByCurrency',
        agent: 'transactions',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
    getResult(value) {
        return Object.assign(Object.assign({}, value), { data: value.data.map(o => (Object.assign(Object.assign({}, o), { createdAt: new Date(o.createdAt), updatedAt: new Date(o.updatedAt) }))) });
    },
});
// endregion
export const currencyTransfer = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'convert_convertWebsite',
        agent: 'transactions',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const checkMyTransactionForCurrency = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_getMyCountDebitTransactions',
        agent: 'transactions',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getTestnetLis = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_getTestnetLis',
        agent: 'transactions',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
